const newgameAuth = {
  th: {
    "ng.auth.action.ok": "ตกลง",
    "ng.auth.validation.phone_required": "กรุณากรอกหมายเลขโทรศัพท์",
    "ng.auth.validation.phone_digits":
      "กรุณากรอกหมายเลขโทรศัพท์ {{digits}} หลัก",
    "ng.auth.validation.phone_10_or_11":
      "กรุณากรอกหมายเลขโทรศัพท์ 10 หรือ 11 หลัก",
    "ng.auth.validation.password_min_6":
      "รหัสผ่านต้องมีความยาวอย่างน้อย 6 ตัวอักษร",
    "ng.auth.source.label": "แหล่งที่มา",
    "ng.auth.registration.details": "ข้อมูลการสมัครสมาชิก",
    "ng.auth.registration.name_must_match_bank":
      "ชื่อ-นามสกุล ต้องตรงกับชื่อในสมุดบัญชีธนาคารเท่านั้น",
    "ng.auth.registration.account_cannot_change":
      "ทางเราจะไม่สามารถแก้ไขเลขบัญชีได้ ไม่ว่ากรณีใดก็ตาม",
    "ng.auth.registration.transfer_account_must_match":
      "บัญชีที่โอนเงินเข้ามาต้องเป็นบัญชีที่สมัครเท่านั้น",
    "ng.auth.card.number": "หมายเลขบัตร",
    "ng.auth.card.holder_name": "ชื่อผู้ถือบัตร",
    "ng.auth.bank.selected": "ธนาคารที่เลือก",
    "ng.auth.bank.account_number": "เลขบัญชีธนาคาร",
    "ng.auth.bank.logo_alt": "โลโก้ธนาคาร {{bank}}",
    "ng.auth.site_logo_alt": "โลโก้เว็บไซต์",
    "ng.auth.registration.steps_aria": "ขั้นตอนสมัครสมาชิก",
    "ng.auth.validation.username_required": "กรุณากรอกชื่อผู้ใช้งาน",
    "ng.auth.maintenance_message":
      "เนื่องจากขณะนี้ระบบอยู่ในช่วงปิดปรับปรุง ขออภัยในความไม่สะดวกค่ะ",
    "ng.auth.account.exists": "มีข้อมูลบัญชีในระบบ",
    "ng.auth.validation.current_password_required":
      "กรุณากรอกรหัสผ่านเดิม",
    "ng.auth.validation.current_password_min_6":
      "รหัสผ่านเดิมต้องมีอย่างน้อย 6 ตัวอักษร",
    "ng.auth.validation.current_password_incorrect":
      "รหัสผ่านเดิมไม่ถูกต้อง",
    "ng.auth.validation.new_password_required": "กรุณากรอกรหัสผ่านใหม่",
    "ng.auth.validation.new_password_min_6":
      "รหัสผ่านใหม่ต้องมีอย่างน้อย 6 ตัวอักษร",
    "ng.auth.validation.confirm_new_password_required":
      "กรุณายืนยันรหัสผ่านใหม่",
    "ng.auth.validation.confirm_new_password_min_6":
      "การยืนยันรหัสผ่านใหม่ต้องมีอย่างน้อย 6 ตัวอักษร",
    "ng.auth.validation.new_password_mismatch":
      "รหัสผ่านใหม่และการยืนยันรหัสผ่านไม่ตรงกัน",
    "ng.auth.password.changed_success": "เปลี่ยนรหัสผ่านสำเร็จ",
    "ng.auth.account.title": "ข้อมูลบัญชี",
    "ng.auth.account.greeting": "คุณ{{name}}",
    "ng.auth.account.name": "ชื่อบัญชี",
    "ng.auth.account.game_password": "รหัสผ่านเข้าเกม",
    "ng.auth.copy_success": "คัดลอก {{item}} สำเร็จ",
    "ng.auth.wallet.add": "เพิ่ม Wallet ID",
    "ng.auth.wallet.add_success": "เพิ่ม Wallet ID สำเร็จ",
    "ng.auth.wallet.how_to_find": "วิธีตรวจสอบ Wallet ID",
    "ng.auth.wallet.example_alt": "ตัวอย่างหน้าจอ Wallet ID",
    "ng.auth.contact.channels": "ช่องทางการติดต่อ",
    "ng.auth.contact.available_24_hours":
      "ติดต่อสอบถามผ่านแอดมินได้ตลอด 24 ชั่วโมง",
    "ng.auth.contact.line_alt": "ติดต่อแอดมินผ่าน LINE",
    "ng.auth.contact.telegram_alt": "ติดต่อแอดมินผ่าน Telegram",
    "ng.auth.session.modal_closes_in":
      "หน้าต่างนี้จะปิดอัตโนมัติใน {{seconds}} วินาที",
    "ng.auth.session.member_promotion_alt":
      "โปรโมชั่นสมาชิกหลังเข้าสู่ระบบ",
  },
  en: {
    "ng.auth.action.ok": "OK",
    "ng.auth.validation.phone_required": "Please enter your phone number",
    "ng.auth.validation.phone_digits":
      "Please enter a {{digits}}-digit phone number",
    "ng.auth.validation.phone_10_or_11":
      "Please enter a 10- or 11-digit phone number",
    "ng.auth.validation.password_min_6":
      "Password must be at least 6 characters",
    "ng.auth.source.label": "Source",
    "ng.auth.registration.details": "Registration details",
    "ng.auth.registration.name_must_match_bank":
      "Your full name must exactly match the name on your bank account",
    "ng.auth.registration.account_cannot_change":
      "The bank account number cannot be changed under any circumstances",
    "ng.auth.registration.transfer_account_must_match":
      "Transfers must come from the bank account used to register",
    "ng.auth.card.number": "Card number",
    "ng.auth.card.holder_name": "Cardholder name",
    "ng.auth.bank.selected": "Selected bank",
    "ng.auth.bank.account_number": "Bank account number",
    "ng.auth.bank.logo_alt": "{{bank}} bank logo",
    "ng.auth.site_logo_alt": "Website logo",
    "ng.auth.registration.steps_aria": "Registration steps",
    "ng.auth.validation.username_required": "Please enter your username",
    "ng.auth.maintenance_message":
      "The system is currently under maintenance. We apologize for the inconvenience.",
    "ng.auth.account.exists": "This account is already registered",
    "ng.auth.validation.current_password_required":
      "Please enter your current password",
    "ng.auth.validation.current_password_min_6":
      "Current password must be at least 6 characters",
    "ng.auth.validation.current_password_incorrect":
      "Current password is incorrect",
    "ng.auth.validation.new_password_required":
      "Please enter a new password",
    "ng.auth.validation.new_password_min_6":
      "New password must be at least 6 characters",
    "ng.auth.validation.confirm_new_password_required":
      "Please confirm your new password",
    "ng.auth.validation.confirm_new_password_min_6":
      "Password confirmation must be at least 6 characters",
    "ng.auth.validation.new_password_mismatch":
      "New password and confirmation do not match",
    "ng.auth.password.changed_success": "Password changed successfully",
    "ng.auth.account.title": "Account information",
    "ng.auth.account.greeting": "{{name}}",
    "ng.auth.account.name": "Account name",
    "ng.auth.account.game_password": "Game password",
    "ng.auth.copy_success": "Copied {{item}} successfully",
    "ng.auth.wallet.add": "Add Wallet ID",
    "ng.auth.wallet.add_success": "Wallet ID added successfully",
    "ng.auth.wallet.how_to_find": "How to find your Wallet ID",
    "ng.auth.wallet.example_alt": "Wallet ID screen example",
    "ng.auth.contact.channels": "Contact channels",
    "ng.auth.contact.available_24_hours":
      "Contact our support team 24 hours a day",
    "ng.auth.contact.line_alt": "Contact support via LINE",
    "ng.auth.contact.telegram_alt": "Contact support via Telegram",
    "ng.auth.session.modal_closes_in":
      "This window will close automatically in {{seconds}} seconds",
    "ng.auth.session.member_promotion_alt":
      "Member promotion shown after login",
  },
  cn: {
    "ng.auth.action.ok": "确定",
    "ng.auth.validation.phone_required": "请输入手机号码",
    "ng.auth.validation.phone_digits": "请输入{{digits}}位手机号码",
    "ng.auth.validation.phone_10_or_11": "请输入10位或11位手机号码",
    "ng.auth.validation.password_min_6": "密码至少需要6个字符",
    "ng.auth.source.label": "来源",
    "ng.auth.registration.details": "注册信息",
    "ng.auth.registration.name_must_match_bank":
      "姓名必须与银行账户持有人姓名完全一致",
    "ng.auth.registration.account_cannot_change":
      "银行账号一经提交，任何情况下均无法修改",
    "ng.auth.registration.transfer_account_must_match":
      "转账账户必须与注册时使用的银行账户一致",
    "ng.auth.card.number": "卡号",
    "ng.auth.card.holder_name": "持卡人姓名",
    "ng.auth.bank.selected": "已选银行",
    "ng.auth.bank.account_number": "银行账号",
    "ng.auth.bank.logo_alt": "{{bank}}银行标志",
    "ng.auth.site_logo_alt": "网站标志",
    "ng.auth.registration.steps_aria": "注册步骤",
    "ng.auth.validation.username_required": "请输入用户名",
    "ng.auth.maintenance_message":
      "系统目前正在维护，给您带来不便，敬请谅解。",
    "ng.auth.account.exists": "该账户已注册",
    "ng.auth.validation.current_password_required": "请输入当前密码",
    "ng.auth.validation.current_password_min_6": "当前密码至少需要6个字符",
    "ng.auth.validation.current_password_incorrect": "当前密码不正确",
    "ng.auth.validation.new_password_required": "请输入新密码",
    "ng.auth.validation.new_password_min_6": "新密码至少需要6个字符",
    "ng.auth.validation.confirm_new_password_required": "请确认新密码",
    "ng.auth.validation.confirm_new_password_min_6":
      "确认密码至少需要6个字符",
    "ng.auth.validation.new_password_mismatch": "新密码与确认密码不一致",
    "ng.auth.password.changed_success": "密码修改成功",
    "ng.auth.account.title": "账户信息",
    "ng.auth.account.greeting": "{{name}}",
    "ng.auth.account.name": "账户姓名",
    "ng.auth.account.game_password": "游戏密码",
    "ng.auth.copy_success": "已成功复制{{item}}",
    "ng.auth.wallet.add": "添加 Wallet ID",
    "ng.auth.wallet.add_success": "Wallet ID 添加成功",
    "ng.auth.wallet.how_to_find": "如何查找 Wallet ID",
    "ng.auth.wallet.example_alt": "Wallet ID 页面示例",
    "ng.auth.contact.channels": "联系方式",
    "ng.auth.contact.available_24_hours": "全天24小时联系客服咨询",
    "ng.auth.contact.line_alt": "通过 LINE 联系客服",
    "ng.auth.contact.telegram_alt": "通过 Telegram 联系客服",
    "ng.auth.session.modal_closes_in":
      "此窗口将在{{seconds}}秒后自动关闭",
    "ng.auth.session.member_promotion_alt": "登录后显示的会员优惠",
  },
  mm: {
    "ng.auth.action.ok": "အိုကေ",
    "ng.auth.validation.phone_required": "ကျေးဇူးပြု၍ ဖုန်းနံပါတ်ထည့်ပါ",
    "ng.auth.validation.phone_digits":
      "ကျေးဇူးပြု၍ ဂဏန်း {{digits}} လုံးပါသော ဖုန်းနံပါတ်ကို ထည့်ပါ",
    "ng.auth.validation.phone_10_or_11":
      "ကျေးဇူးပြု၍ ဂဏန်း ၁၀ လုံး သို့မဟုတ် ၁၁ လုံးပါသော ဖုန်းနံပါတ်ကို ထည့်ပါ",
    "ng.auth.validation.password_min_6":
      "စကားဝှက်သည် အနည်းဆုံး အက္ခရာ ၆ လုံး ရှိရပါမည်",
    "ng.auth.source.label": "ရင်းမြစ်",
    "ng.auth.registration.details": "အဖွဲ့ဝင်လျှောက်ထားမှု အချက်အလက်",
    "ng.auth.registration.name_must_match_bank":
      "အမည်နှင့် မျိုးရိုးအမည်သည် ဘဏ်စာရင်းရှိ အမည်နှင့် အတိအကျ ကိုက်ညီရပါမည်",
    "ng.auth.registration.account_cannot_change":
      "ဘဏ်အကောင့်နံပါတ်ကို မည်သည့်အခြေအနေတွင်မဆို ပြင်ဆင်၍မရပါ",
    "ng.auth.registration.transfer_account_must_match":
      "ငွေလွှဲသည့်ဘဏ်အကောင့်သည် စာရင်းသွင်းရာတွင် အသုံးပြုသည့်အကောင့်နှင့် တူညီရပါမည်",
    "ng.auth.card.number": "ကတ်နံပါတ်",
    "ng.auth.card.holder_name": "ကတ်ပိုင်ရှင်အမည်",
    "ng.auth.bank.selected": "ရွေးချယ်ထားသောဘဏ်",
    "ng.auth.bank.account_number": "ဘဏ်အကောင့်နံပါတ်",
    "ng.auth.bank.logo_alt": "{{bank}} ဘဏ်လိုဂို",
    "ng.auth.site_logo_alt": "ဝဘ်ဆိုက်လိုဂို",
    "ng.auth.registration.steps_aria": "အကောင့်ဖွင့်ခြင်း အဆင့်များ",
    "ng.auth.validation.username_required":
      "ကျေးဇူးပြု၍ အသုံးပြုသူအမည်ထည့်ပါ",
    "ng.auth.maintenance_message":
      "လက်ရှိတွင် စနစ်ပြုပြင်ထိန်းသိမ်းနေပါသဖြင့် အဆင်မပြေမှုအတွက် တောင်းပန်အပ်ပါသည်။",
    "ng.auth.account.exists": "ဤအကောင့်ကို စာရင်းသွင်းထားပြီးဖြစ်သည်",
    "ng.auth.validation.current_password_required":
      "ကျေးဇူးပြု၍ လက်ရှိစကားဝှက်ထည့်ပါ",
    "ng.auth.validation.current_password_min_6":
      "လက်ရှိစကားဝှက်သည် အနည်းဆုံး အက္ခရာ ၆ လုံး ရှိရပါမည်",
    "ng.auth.validation.current_password_incorrect":
      "လက်ရှိစကားဝှက် မမှန်ပါ",
    "ng.auth.validation.new_password_required":
      "ကျေးဇူးပြု၍ စကားဝှက်အသစ်ထည့်ပါ",
    "ng.auth.validation.new_password_min_6":
      "စကားဝှက်အသစ်သည် အနည်းဆုံး အက္ခရာ ၆ လုံး ရှိရပါမည်",
    "ng.auth.validation.confirm_new_password_required":
      "ကျေးဇူးပြု၍ စကားဝှက်အသစ်ကို အတည်ပြုပါ",
    "ng.auth.validation.confirm_new_password_min_6":
      "အတည်ပြုစကားဝှက်သည် အနည်းဆုံး အက္ခရာ ၆ လုံး ရှိရပါမည်",
    "ng.auth.validation.new_password_mismatch":
      "စကားဝှက်အသစ်နှင့် အတည်ပြုစကားဝှက် မကိုက်ညီပါ",
    "ng.auth.password.changed_success": "စကားဝှက် ပြောင်းလဲပြီးပါပြီ",
    "ng.auth.account.title": "အကောင့်အချက်အလက်",
    "ng.auth.account.greeting": "{{name}}",
    "ng.auth.account.name": "အကောင့်အမည်",
    "ng.auth.account.game_password": "ဂိမ်းစကားဝှက်",
    "ng.auth.copy_success": "{{item}} ကို ကူးယူပြီးပါပြီ",
    "ng.auth.wallet.add": "Wallet ID ထည့်ရန်",
    "ng.auth.wallet.add_success": "Wallet ID ထည့်ပြီးပါပြီ",
    "ng.auth.wallet.how_to_find": "Wallet ID ရှာဖွေနည်း",
    "ng.auth.wallet.example_alt": "Wallet ID မျက်နှာပြင် နမူနာ",
    "ng.auth.contact.channels": "ဆက်သွယ်ရန် လမ်းကြောင်းများ",
    "ng.auth.contact.available_24_hours":
      "ဝန်ဆောင်မှုအဖွဲ့ကို ၂၄ နာရီ ဆက်သွယ်မေးမြန်းနိုင်ပါသည်",
    "ng.auth.contact.line_alt":
      "LINE မှတစ်ဆင့် ဝန်ဆောင်မှုအဖွဲ့ကို ဆက်သွယ်ရန်",
    "ng.auth.contact.telegram_alt":
      "Telegram မှတစ်ဆင့် ဝန်ဆောင်မှုအဖွဲ့ကို ဆက်သွယ်ရန်",
    "ng.auth.session.modal_closes_in":
      "ဤဝင်းဒိုးသည် {{seconds}} စက္ကန့်အတွင်း အလိုအလျောက် ပိတ်ပါမည်",
    "ng.auth.session.member_promotion_alt":
      "အကောင့်ဝင်ပြီးနောက် ပြသသည့် အဖွဲ့ဝင်ပရိုမိုးရှင်း",
  },
};

export default newgameAuth;
